import { ParticipantImportFileRow } from './Store/Types';

export const sample: ParticipantImportFileRow[] = [
  {
    email: 'mjones@example.com',
    firstname: 'Mike',
    lastname: 'Jones',
  },
  {
    email: 'tperkins@example.com',
    firstname: 'Tina',
    lastname: 'Perkins',
  },
  {
    email: 'rpatel@example.com',
    firstname: 'Raj',
    lastname: 'Patel',
  },
  {
    email: 'ekim@example.com',
    firstname: 'Emily',
    lastname: 'Kim',
  },
];
